import { render, staticRenderFns } from "./SelectSharingPermissions.vue?vue&type=template&id=271b4a35&scoped=true"
import script from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
export * from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
import style0 from "./SelectSharingPermissions.vue?vue&type=style&index=0&id=271b4a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b4a35",
  null
  
)

export default component.exports